module.exports = __webpack_public_path__ + "static/proje-ulastirma-5dde55d857224579053ab9e844cc6ba3.png";